// mcn-frontend/src/pages/Unauthorized.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import './Unauthorized.css';

const Unauthorized = () => {
  const navigate = useNavigate();
  const { currentUser, getRoleDisplayName } = useUser();

  const handleGoBack = () => {
    // Navigate to user's appropriate dashboard
    const roleRoutes = {
      'SUPER_ADMIN': '/super-admin-dashboard',
      'ADMIN': '/admin-dashboard',
      'MANAGER': '/manager-dashboard',
      'FINANCE_MANAGER': '/finance-dashboard',
      'CONTENT_MANAGER': '/content-moderation',
      'AGGREGATOR': '/aggregator-dashboard',
      'CHANNEL_OWNER': '/channel-dashboard',
      'CREATOR': '/creator-dashboard',
      'CONTENT_CREATOR': '/creator-dashboard',
      'STUDIO': '/studio-dashboard',
      'INVESTOR': '/investor-dashboard',
      'PREMIUM_INVESTOR': '/investor-dashboard',
      'SUPPORT_AGENT': '/support-dashboard',
      'ANALYTICS_VIEWER': '/analytics-dashboard',
      'USER': '/dashboard'
    };

    const dashboard = roleRoutes[currentUser?.role] || '/dashboard';
    navigate(dashboard);
  };

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <div className="unauthorized-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="#ef4444"/>
            <path d="M11 7h2v6h-2zm0 8h2v2h-2z" fill="#ef4444"/>
          </svg>
        </div>
        
        <h1>Access Denied</h1>
        <p className="unauthorized-message">
          You don't have permission to access this page.
        </p>
        
        {currentUser && (
          <div className="user-info">
            <p>Your current role: <strong>{getRoleDisplayName()}</strong></p>
            <p className="hint">
              If you believe you should have access to this area, please contact your administrator.
            </p>
          </div>
        )}
        
        <div className="unauthorized-actions">
          <button className="btn-primary" onClick={handleGoBack}>
            Go to Dashboard
          </button>
          <button className="btn-secondary" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;

// mcn-frontend/src/pages/Unauthorized.css
/*
.unauthorized-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.unauthorized-card {
  background: white;
  border-radius: 12px;
  padding: 48px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.unauthorized-icon {
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.unauthorized-card h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 16px;
}

.unauthorized-message {
  font-size: 18px;
  color: #6b7280;
  margin-bottom: 32px;
}

.user-info {
  background: #f9fafb;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 32px;
}

.user-info p {
  margin: 8px 0;
  color: #4b5563;
}

.user-info strong {
  color: #1f2937;
  font-weight: 600;
}

.hint {
  font-size: 14px;
  color: #6b7280;
  margin-top: 12px;
}

.unauthorized-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.btn-primary, .btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.btn-secondary {
  background: #f3f4f6;
  color: #4b5563;
}

.btn-secondary:hover {
  background: #e5e7eb;
}

@media (max-width: 640px) {
  .unauthorized-card {
    padding: 32px 24px;
  }
  
  .unauthorized-actions {
    flex-direction: column;
    width: 100%;
  }
  
  .btn-primary, .btn-secondary {
    width: 100%;
  }
}
*/